import { isRequired } from '@gef-ui/form-core/validations/validationFunctions/common';

import {
	isDateLessThanYearInPastConsideringWholeStartingMonthOrNotInFuture,
	isDateWithOrder,
	isFullySpecifiedDate,
} from 'app/forms/validations/common';
import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

import { SEARCH_TYPE } from './constants';

export const TASK_STATISTICS_FORM_NAME = 'taskStatistics-filter';

const { dateFrom, dateTo, channel, region, agency, manager, seller } = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	statType: 'statType',
	dateFrom,
	dateTo,
	channel,
	region,
	agency,
	manager,
	seller,
};

export default () => ({
	// filterForm
	[FIELDS.statType]: {
		deepPath: [FIELDS.statType],
		validations: [isRequired()],
	},
	[FIELDS.dateFrom]: {
		deepPath: [FIELDS.dateFrom],
		dependentFields: [FIELDS.dateTo],
		validations: [
			isRequired({
				when: ({ formData }) => formData.statType !== SEARCH_TYPE.status,
			}),
			isFullySpecifiedDate({
				when: ({ formData }) => formData.statType !== SEARCH_TYPE.status,
			}),
			isDateWithOrder({ fromFieldName: FIELDS.dateFrom, toFieldName: FIELDS.dateTo }),
			isDateLessThanYearInPastConsideringWholeStartingMonthOrNotInFuture(),
		],
	},
	[FIELDS.dateTo]: {
		deepPath: [FIELDS.dateTo],
		dependentFields: [FIELDS.dateFrom],
		validations: [
			isRequired({
				when: ({ formData }) => formData.statType !== SEARCH_TYPE.status,
			}),
			isFullySpecifiedDate({
				when: ({ formData }) => formData.statType !== SEARCH_TYPE.status,
			}),
			isDateWithOrder({ fromFieldName: FIELDS.dateFrom, toFieldName: FIELDS.dateTo }),
			isDateLessThanYearInPastConsideringWholeStartingMonthOrNotInFuture(),
		],
	},

	// sidebar orgStructure
	[FIELDS.channel]: {
		deepPath: [FIELDS.channel],
		validations: [isRequired()],
	},
	[FIELDS.region]: {
		deepPath: [FIELDS.region],
		validations: [isRequired()],
	},
	[FIELDS.agency]: {
		deepPath: [FIELDS.agency],
		validations: [isRequired()],
	},
	[FIELDS.manager]: {
		deepPath: [FIELDS.manager],
		validations: [isRequired()],
	},
	[FIELDS.seller]: {
		deepPath: [FIELDS.seller],
		validations: [],
	},
});
